<template>
    <v-container fluid>

        <v-row justify="start" class="mt-6">
            <v-col>
                <h2>問卷名稱: {{ survey_name }}</h2>
            </v-col>            
            <v-col align="right">
                <v-btn color="success" @click="back()">返回</v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <span>廠商名稱: {{ vendor_name }}</span>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <span>醫師名稱: {{doctor_name }}</span>
            </v-col>
            <v-divider
                class="mx-4"
                :inset="inset"
                horizon
            ></v-divider>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-row >
                    <span class="fontStyle">選擇面額: </span>&nbsp;&nbsp;
                    <v-select 
                        style="max-width: 100px !important;"
                        v-model="select_denominations" 
                        :items="denomination_list"
                        placeholder="選擇"
                        @change="choose_denomination()"
                        single-line
                        outlined
                    >
                    </v-select>
                </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-row >
                    <span class="fontStyle">設定張數: </span>&nbsp;&nbsp;
                    <v-text-field 
                        v-model="number"
                        style="max-width: 100px !important;"
                        min="0"
                        :max="maxNumber"
                        @focus="check()"
                        v-on="multiply()"
                        type="Number"
                        outlined
                    >
                    </v-text-field>
                    <span class="fontStyle" style="color: grey">剩餘張數: {{ maxNumber }}
                    </span>
                </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <span>預估總共將發出 {{point}} 點 </span>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-btn color="success" @click="save()">儲存</v-btn>
            </v-col>
             <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <span>(備註: 問卷將在點數發放完畢後自動關閉)</span>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import bus from '../nav/bus'

var host_url = process.env.VUE_APP_HOST_URL 
export default {
    watch:{
        number: function(val){
            console.log(val)
            if(val > this.maxNumber){
                this.number = this.maxNumber
            }
        }
    },
    data(){
        return {
            type_: "",
            // 問卷, 廠商, 醫師名稱
            survey_name: '測試問卷',
            vendor_name: '',
            doctor_name: '',
            
            survey_id: '',

            vendor_id: parseInt(localStorage.getItem('vendor_id')),
            // v-divider
            inset: false,
            // 計算參數 
            select_denominations: '', //面額
            denomination_list: [50, 100, 150], //選擇面額大小
            number: 0, //選擇張數
            point: 0, //預估點數

            maxNumber: 0, //限制最大值, 依發出數量提供最大限制

        }
    },
    created(){
        this.init()
    },
    methods: {
        init(){

            let params = JSON.parse(localStorage.getItem('linePointData'))
            this.survey_name = params.title;
            this.vendor_name = params.vendor_name;
            this.doctor_name = params.doctor_name;
            this.survey_id = params.account_survey_id;
            // console.log(this.survey_id)

            axios.get(host_url+'get_line_point_denomination/')
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    this.denomination_list = tmp.data
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                }
            })
            .catch((error) => {
                console.log(error)
            })
        },
        choose_denomination(){
            // console.log(this.select_denominations)
            let data = { "data": this.select_denominations}
            axios.post(host_url+'get_line_point_max_number/', data)
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    this.maxNumber = tmp.data
                    if(this.maxNumber == 0){
                        bus.$emit('alert', {msg: '此面額剩餘數量為0', title: "提示",　check: "我知道了"})
                    }
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                }
            })
            .catch((error) => {
                console.log(error)
            })
            this.multiply()
        },
        multiply(){
            
            this.point = this.number * this.select_denominations;
        },
        check(){
            if(this.select_denominations == ''){
                bus.$emit('alert', {msg: "請先選擇面額", title: "提示",　check: "我知道了"})
                return
            }
        },
        save(){
            let data = { "denomination": this.select_denominations, "Number": this.number, "survey_id": this.survey_id, "maxNumber": this.maxNumber}
            axios.post(host_url+'save_survey_line_point/', data)
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                    this.$router.push('/line_point_setting')
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                }
            })
            .catch((error) => {
                console.log(error)
            })
        },
        back(){
            this.$router.push('/line_point_setting')
        }
    }
}
</script>
<style scoped>
.fontStyle{
    margin-left: 12px;
    line-height: 3.5;
}
</style>